import React, { Fragment } from 'react';
import Set from './Set';
import { generateId } from '../utils/genericUtils';

export default function CustomFilterSets ({sets, setSets, onChange, fields, disableUnique, handleUpdateExpression, handleUpdateSetOperator, 
  handleRemoveSet, handleAddExpression, handleRemoveExpression, expressionTemplate, userInfo, datasetSelection}) {
    let currentSets = sets;
    if(!currentSets){
      currentSets = {
        [generateId()]: {
          mustMatchAll: true,
          expression: "",
          expressions: {
            [generateId()]: expressionTemplate
          }
        }
      }
      setSets(currentSets)
      onChange({mustMatchAll: true, expression: "", sets: currentSets})
    }
    const currentSetKeys = Object.keys(currentSets)


    return (
      <Fragment>
        {currentSetKeys.map(id => {
          const set = currentSets[id];
          return (
            <Fragment key={id}>
              <Set
                id={id}
                fields={fields}
                mustMatchAll={set.mustMatchAll}
                expressions={set.expressions}
                disableUnique={disableUnique}
                updateExpression={handleUpdateExpression}
                updateSetOperator={handleUpdateSetOperator}
                removeSet={handleRemoveSet}
                addExpression={handleAddExpression}
                removeExpression={handleRemoveExpression}
                overrideStringOperators={false}
                userInfo={userInfo}
                datasetSelection={datasetSelection}
              />
            </Fragment>
          );
        })}
      </Fragment>
  )
}
